"use strict";
/*
  Starting in 2025, the JavaScript codebase for the dvinci theme is being migrated to modern TypeScript.

  This marks the beginning of a broader modularization and modernization process across the entire project.
  The goal is to improve maintainability, scalability, and long-term clarity by introducing consistent
  architecture, strong typing, and reusable component structures.

  All new functionality should be implemented using TypeScript where possible.
*/
Object.defineProperty(exports, "__esModule", { value: true });
require("./custom.js"); // Importing custom.js for legacy support
require("./block-functions.js"); // Importing custom.js for legacy support
// B L O C K S 
require("./blocks/vertical-features"); // Importing custom.js for legacy support
var slider_1 = require("./slider/slider");
document.addEventListener("DOMContentLoaded", function () {
    (0, slider_1.allSliderInit)();
});
